import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";

type Props = {
  columns: columnTypes[];
  rows: any[];
  onAddNew:any ;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const SubCourseListing = ({
  columns,
  rows,
  onAddNew,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
   
      <div className="flex flex-col h-full">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            pageTitle="SubCourses"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: "Add New",
              onClick: onAddNew,
            }}
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            rows={rows}
            columns={columns}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
   
  );
};

export default SubCourseListing;
